import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./Sidebar";
import PdfDropZone from "./PdfDropZone";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  addToArrayField,
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  updateDocDataField,
} from "../../models/DataFunctions";
import { useAuth } from "../../auth/FirebaseAuth";
import { getUserById } from "../../models/UserFunctions";

import SecondaryButton from "../../buttons/SecondaryButton";
import Space from "../../layout/Space";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import edit from "../../api/sign/edit";
import sendHS1 from "../../api/sign/sendHS1";
import { useAppContext } from "../../config/AppContext";
import { useSnackbar } from "notistack";
import Icon1 from "../../icons/Icon";
import UploadMultiPDF from "../../api/upload/UploadMultiPDF";
import getTemporaryUrl from "../../api/getTemporaryUrl";
import { getDocument } from "pdfjs-dist";
import TextField2 from "../../textfields/TextField2";
import Modal1 from "../../modals/Modal1";
import SmallSpinner from "../../loading/SmallSpinner";
import { message } from "antd";
import sendRT1 from "../../api/sign/sendRT1";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import downloadFile from "../../api/download/downloadFile";
import { addActivityLog } from "../../config/OnlineStatus";
import PrimaryButton from "../../buttons/PrimaryButton";

const Hexasign = ({
  folder,
  document = null,
  file_url = null,
  onClose,
  onFetch = null,
  rt_batiment = false,
  operator_id = null,
  mode = "choice",
  from_extract = false,
  userData = null,
  fileName = null,
  rapportType = null,
}) => {
  const [selectedFileUrl, setSelectedFileUrl] = useState(file_url);
  const [signFields, setSignFields] = useState([]);
  const [pdfDimensions, setPdfDimensions] = useState({
    width: 1190.56,
    height: 1683.78,
  });
  const [customTextFields, setCustomTextFields] = useState([]);
  const [newTextFieldName, setNewTextFieldName] = useState(""); // Track new text field input
  const [org_id, set_org_id] = useState(null);
  const { currentUser, loading } = useAuth();
  const [orgData, setOrgData] = useState(null);
  const [editorMode, setEditorMode] = useState(mode);
  const [editFields, setEditFields] = useState([]);
  const fieldIdCounter = useRef(0);
  const [emailOpen, setEmailOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal for adding custom text fields
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const BACK_PAGE_WIDTH = 210;
  const BACK_PAGE_HEIGHT = 297;
  const NEW_BACK_PAGE_WIDTH = 595.2755905511812;
  const NEW_BACK_PAGE_HEIGHT = 841.8897637795277;
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loadingData, setLoadingData] = useState(false);

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid); // Fetch user by ID using function
        set_org_id(user.org_id);
        const orgData = await getOrgDataById(user.org_id);
        setOrgData(orgData);
        if (orgData && orgData.saved_champs) {
          const customFields = orgData.saved_champs.map((field) => field.label);
          setCustomTextFields(customFields);
        }
        if (rt_batiment) {
          addField("Signature", "Signature", 480, 880, 300, 150, 6);
          addField("Date", "Date", 420, 880, 300, 50, 6);
        } else {
          if (
            folder.last_file_extracted_sign_coords &&
            document &&
            document.documentxx?.id === "fffff" &&
            from_extract
          ) {
            let sign_coords = folder.last_file_extracted_sign_coords;
            const isolant_coords = sign_coords.isolant;
            const carbone_coords = sign_coords.carbone;
            const isolant_pages =
              sign_coords.isolant.length > 0
                ? Math.max(...isolant_coords.map((coords) => coords.page))
                : 0; // isolant are always in the start of the pdf
            let adjusted_y, adjusted_x;
            isolant_coords.forEach((isolant_coords) => {
              adjusted_y =
                (isolant_coords.y * pdfDimensions.height) /
                NEW_BACK_PAGE_HEIGHT;
              adjusted_x =
                1 +
                (isolant_coords.x * pdfDimensions.width) / NEW_BACK_PAGE_WIDTH;

              let h, w;
              if (isolant_coords.type === "Signature") {
                h = 85;
                w = 261;
              } else if (isolant_coords.type === "Tampon") {
                h = 85;
                w = 239;
              } else {
                h = 35;
                w = 400;
              }
              let page = isolant_coords.page;
              if (isolant_coords.type === "Adresse") {
                addField(
                  "Text",
                  isolant_coords.type,
                  adjusted_y,
                  adjusted_x,
                  w,
                  h,
                  page
                );
              } else {
                addField(
                  isolant_coords.type,
                  isolant_coords.type,
                  adjusted_y,
                  adjusted_x,
                  w,
                  h,
                  page
                );
              }
            });
            carbone_coords.forEach((carbone_coords) => {
              let h, w;
              if (carbone_coords.type === "Signature") {
                h = 85;
                w = 262;
              } else if (carbone_coords.type === "Tampon") {
                h = 85;
                w = 240;
              } else {
                h = 35;
                w = 400;
              }
              let adjusted_y, adjusted_x;
              adjusted_y =
                (carbone_coords.y * pdfDimensions.height) /
                NEW_BACK_PAGE_HEIGHT;
              adjusted_x =
                (carbone_coords.x * pdfDimensions.width) / NEW_BACK_PAGE_WIDTH;

              const page = isolant_pages + carbone_coords.page;
              addField(
                carbone_coords.type,
                carbone_coords.type,
                adjusted_y,
                adjusted_x,
                w,
                h,
                page
              );
            });
          }

          if (document?.documentxx?.id === "IGjNsygZZjmq7ucUirV6") {
            addField("Signature", "Signature", 1340, 830, 250, 80, 1);
            addField("Text", "Téléphone", 1140, 810, 250, 40, 1);
            addField("Text", "Email", 1140, 350, 250, 40, 1);
            addField("Text", "Nom et prénom", 1090, 350, 250, 40, 1);
            addField("Text", "Ville", 1280, 500, 250, 40, 1);

            addField("Date", "Date", 1280, 150, 250, 40, 1);
          }
        }
      } catch (error) {
        console.error("Error fetching custom fields: ", error);
      }
    }
  };

  const handleUpload = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();

      await getTemporaryUrl(token, "all", document.id, folder.id, prefix);
      let updated_document = await getDocDataById("document", document.id);

      if (!updated_document) {
        console.error("Document not found:", document.id);
        handleClickVariant("Erreur lors du chargement du document", "error");
        return;
      }

      if (!updated_document.files || updated_document.files.length === 0) {
        console.error("No files found in document:", document.id);
        handleClickVariant("Aucun fichier trouvé dans le document", "error");
        return;
      }

      let files = updated_document.files;
      setSelectedFileUrl(files[files.length - 1].url);
    } catch (error) {
      console.error("Error in handleUpload:", error);
      handleClickVariant("Erreur lors du chargement du fichier", "error");
    }
  };

  const handleEditorMode = (newMode) => {
    setEditorMode(newMode);
  };
  const addField = (
    type,
    name = null,
    top = 100,
    left = 100,
    width = 500,
    height = 120,
    page = 1,
    target = "sign"
  ) => {
    const newField = {
      id: fieldIdCounter.current,
      type: type,
      name: name || type, // Default name is the type if no name is provided
      width: width,
      height: height,
      top: top, // Place field 100px below the current scroll position
      left: left,
      page: page,
    };
    fieldIdCounter.current += 1;

    if (target == "sign") {
      setSignFields((prevFields) => [...prevFields, newField]);
    } else {
      setEditFields((prevFields) => [...prevFields, newField]);
    }
  };

  const handleUpdateFields = (
    id,
    type,
    name = null,
    top = 100,
    left = 100,
    width = 150,
    height = 80,
    page = 1,
    target = "sign"
  ) => {
    let updateName = name ? name : type;
    if (target === "sign") {
      setSignFields((prevFields) =>
        prevFields.map((field) =>
          field.id === id
            ? {
                ...field,
                type: type,
                name: updateName,
                width: width,
                height: height,
                top: top,
                left: left,
                page: page,
              }
            : field
        )
      );
    } else {
      setEditFields((prevFields) =>
        prevFields.map((field) =>
          field.id === id
            ? {
                ...field,
                type: type,
                content: updateName,
                name: updateName,
                width: width,
                height: height,
                top: top,
                left: left,
                page: page,
              }
            : field
        )
      );
    }
  };

  const handleFieldDelete = (id, target) => {
    if (target === "sign") {
      setSignFields((prevFields) => prevFields.filter((field) => field.id !== id));
    } else {
      setEditFields((prevFields) => prevFields.filter((field) => field.id !== id));
    }
  };

  useEffect(() => {
    if (file_url) {
      setSelectedFileUrl(file_url);
    }
  }, [file_url]);

  useEffect(() => {
    handleFetchData();
  }, [currentUser]);

  const handleFieldResize = (id, width, height, target) => {
    if (target === "sign") {
      setSignFields((prevFields) =>
        prevFields.map((field) =>
          field.id === id ? { ...field, width, height } : field
        )
      );
    } else {
      setEditFields((prevFields) =>
        prevFields.map((field) =>
          field.id === id ? { ...field, width, height } : field
        )
      );
    }
  };

  const handleAddCustomTextField = async () => {
    if (newTextFieldName.trim()) {
      setCustomTextFields((prev) => [...prev, newTextFieldName.trim()]);
      setNewTextFieldName(""); // Clear input after adding
      setIsModalOpen(false); // Close the modal
      if (org_id) {
        try {
          let orgRef = doc(getFirestore(), "org", org_id);
          const new_field = { label: newTextFieldName.trim(), type: "Text" };
          await addToArrayField(orgRef, "saved_champs", new_field);
        } catch (error) {
          console.error("Error adding field to Firestore: ", error);
        }
      } else {
        console.error(" is null, cannot add field to Firestore");
      }
    }
  };

  const handleRemoveTextField = async (index) => {
    let customTextFieldsNew = customTextFields.filter((_, i) => i !== index);
    setCustomTextFields(customTextFieldsNew);
    let orgRef = doc(getFirestore(), "org", org_id);
    await updateDocDataFieldApi(
      orgRef,
      "saved_champs",
      customTextFieldsNew.map((field) => ({ label: field, type: "Text" })),
      prefix
    );
  };

  const handleDownload = async () => {
    if (!selectedFileUrl) {
      handleClickVariant("Le fichier n'est pas disponible", "error");
      return;
    }
    let randomName = Math.random().toString(16).slice(2);
    let name = fileName ? fileName : randomName;
    let file = {
      url: selectedFileUrl,
      name: name,
    };
    await downloadFile(file);
  };

  const onSign = async () => {
    try {
      if (signFields.length === 0) {
        handleClickVariant(
          "Veuillez ajouter au moins un champ avant d'envoyer le document",
          "error"
        );
        return;
      }
      setLoadingData(true);
      const requestFields = signFields.map((field) => {
        return {
          type: field.type,
          bb: field.left,
          pp: field.top,
          ww: field.width,
          hh: field.height,
          content: "",
          label: field.name,
          page: field.page,
        };
      });
      if (!rt_batiment) {
        await updateDocDataFieldApi(document.ref, "state", "open", prefix);
      }
      const token = await getOrRefreshFirebaseToken();
      const { width, height } = pdfDimensions;
      const forDPE = document?.documentxx?.id === "IGjNsygZZjmq7ucUirV6";
      if (!rt_batiment) {
        await sendHS1(
          requestFields,
          selectedFileUrl,
          token,
          folder.id,
          document.id,
          prefix,
          height,
          width,
          fileName,
          forDPE
        );
        await updateDocDataFieldApi(
          document.ref,
          "champs",
          requestFields,
          prefix
        );
        handleClickVariant(
          "Le document a été envoyé à la signature",
          "success"
        );
        await addActivityLog(
          "Document envoyé à la signature",
          folder.ref,
          orgData.id,
          userData.id,
          "document_signed",
          prefix
        );
      } else {
        await sendRT1(
          requestFields,
          selectedFileUrl,
          token,
          folder.id,
          prefix,
          height,
          width,
          operator_id,
          fileName
        );
      }

      await addActivityLog(
        "ATF RT Batiment signée",
        folder.ref,
        orgData.id,
        userData.id,
        "document_signed",
        prefix
      );

      onFetch();
      setLoadingData(false);
    } catch (error) {
      message.error(
        "Une erreur s'est produite. Merci de réessayer. Si le problème persiste, vous pouvez contacter le support."
      );
    }
  };

  const onEdit = async () => {
    try {
      setLoadingData(true);
      const requestFields = editFields.map((field) => {
        return {
          type: field.type,
          bb: field.left,
          pp: field.top,
          ww: field.width,
          hh: field.height,
          page: field.page,
          content: field.content,
          label: field.name,
        };
      });
      const token = await getOrRefreshFirebaseToken();
      const { width, height } = pdfDimensions;

      let docid = document ? document.id : null;
      const editType = rapportType
        ? "rapport"
        : rt_batiment
          ? "rtb"
          : file_url
            ? "xml"
            : "doc";
      let new_url = await edit(
        requestFields,
        selectedFileUrl,
        token,
        folder.id,
        docid,
        prefix,
        height,
        width,
        editType,
        fileName
      );
      if (rapportType) {
        onClose(); // To go back to "Voir Rapports" view (PdfVisualisateur.js)
        return;
      }
      setSelectedFileUrl(new_url);
      setEditorMode("choice");
      setLoadingData(false);
      setEditFields([]);
    } catch (error) {
      message.error(
        "Une erreur s'est produite. Merci de réessayer. Si le problème persiste, vous pouvez contacter le support."
      );
    }
  };

  return (
    <div
      className={` ${selectedFileUrl ? "h-full w-full  rounded-lg bg-white" : "h-full w-full  items-center justify-center flex flex-col"}`}
    >
      <Modal1 isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl gap-2 ">
          <div className="text-h2">Ajouter un nouveau champ de texte</div>
          <div>
            <TextField2
              autoFocus
              margin="dense"
              label="Nom du champ"
              fullWidth
              value={newTextFieldName}
              onChange={(e) => setNewTextFieldName(e.target.value)}
            />
          </div>
          <div className="flex flex-row justify-between">
            <SecondaryButton onClick={() => setEditorMode(false)}>
              Annuler
            </SecondaryButton>
            <PrimaryButton onClick={handleAddCustomTextField}>
              Ajouter
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      {!selectedFileUrl && (
        <div className="flex flex-row gap-4 items-center justify-center w-c500 bg-white rounded-lg">
          <div className="flex flex-col gap-4 items-center justify-center  w-fit  px-10 py-5">
            <div className="text-h3 text-shadow_50">
              Veuillez ajouter un document PDF
            </div>
            <UploadMultiPDF
              folder={folder}
              docId={document.id}
              prefix={prefix}
              onUpdate={handleUpload}
              large={true}
            />
            <div className="flex flex-row gap-4">
              {" "}
              <PrimaryButton onClick={() => onClose()}>Annuler</PrimaryButton>
              {(document.documentxx?.id === "hhhhh" ||
                document.documentxx?.id === "lllll") &&
                document.files.length > 0 && (
                  <PrimaryButton onClick={() => handleUpload()}>
                    Utiliser l'ATH SPE générée
                  </PrimaryButton>
                )}
            </div>
          </div>{" "}
        </div>
      )}
      {selectedFileUrl && (
        <DndProvider backend={HTML5Backend}>
          <div className="flex h-full w-full overflow-hidden">
            <Sidebar
              editorMode={editorMode}
              handleEditorMode={handleEditorMode}
              handleDownload={handleDownload}
              onSign={onSign}
              handleRemoveTextField={handleRemoveTextField}
              handleAddCustomTextField={handleAddCustomTextField}
              setIsModalOpen={setIsModalOpen}
              onEdit={onEdit}
              customTextFields={customTextFields}
              loadingData={loadingData}
              onClose={onClose}
              fields={
                editorMode === "sign"
                  ? signFields
                  : editorMode === "edit"
                    ? editFields
                    : []
              }
              onlyEdit={rapportType !== null}
            />

            <PdfDropZone
              pdfUrl={selectedFileUrl}
              editFields={editFields}
              signFields={signFields}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setNewTextFieldName={setNewTextFieldName}
              newTextFieldName={newTextFieldName}
              editorMode={editorMode}
              addField={addField}
              handleFieldDelete={handleFieldDelete}
              handleFieldResize={handleFieldResize}
              handleUpdateFields={handleUpdateFields}
              setPdfDimensions={setPdfDimensions}
              pdfDimensions={pdfDimensions}
            />
          </div>
        </DndProvider>
      )}
    </div>
  );
};

export default Hexasign;
